import React from 'react';
import Header from '../components/Header';

const HomePage = () => {
	return (
		<div className="home-page">
			<Header />
		</div>
	);
};

export default HomePage;
